import { useEffect } from 'react';
import WhyShouldYouChooseUs from '../../components/WhyShouldYouChooseUs/WhyShouldYouChooseUs';
import ContactUs from '../../components/ContactUs/ContactUs';
import AboutUsPreviewBlock from '../../components/AboutUsPreviewBlock/AboutUsPreviewBlock';
import CompanyInfo from '../../components/CompanyInfo/CompanyInfo';

export default function AboutUsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <AboutUsPreviewBlock />
      <CompanyInfo />

      <WhyShouldYouChooseUs containerSx={{ paddingBottom: '10vh' }} />

      <ContactUs />
    </div>
  );
}
